import { post } from '@/services/httpMethods'

export interface PublicAppointmentPayload {
  patientName: string
  patientMobile: string
  departmentId?: string
  doctorId: string
  date: string
  time: string
  appointmentType?: string
  notes?: string
}

export interface PublicAppointment {
  id: string
  serialNumber?: number
  date: string
  time: string
  session?: string
  status?: string
}

/**
 * Books a walk-in/new appointment from the public website.
 * Endpoint: POST /api/v1/appointments/public (unauthenticated).
 */
export function createPublicAppointment(payload: PublicAppointmentPayload) {
  return post<PublicAppointment>('/appointments/public', payload)
}
